import React, { useEffect, useCallback, useState} from 'react';
import Publish from './Publish.js';
import List from './List.js';
import EditList from './EditList.js';
import {connect} from 'react-redux';
import '../../../ExploreList.scss';

const ListsView = ({creatingNewList, lists, hide, loadWork, removeList, onListChanged}) => { 
    return (
        <div className="lists-container">
          {lists.map(
              (list, i) =>
                  <List
                    onListChanged={onListChanged}
                    onDelete={() => {
                        onListChanged(list, true);
                        removeList(list);
                    }}
                    removeList={() => removeList(list)}
                    key={list.name} loadWork={loadWork} list={list}/>)}
          {creatingNewList ?
           <EditList hide={onListChanged}/> :
           ''
          }
          <Publish/>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ListsView);
